import { Toaster } from 'react-hot-toast';
import NotificationsModal from './modal/NotificationsModal';

const ResponsiveToaster = () => {
    return (
        <>
            <Toaster
                position="top-right"
                reverseOrder={true}
                toastOptions={{
                    className: 'toast',
                    duration: Infinity
                }}
            />
            <NotificationsModal />
        </>
    );
};

export default ResponsiveToaster;
